/* Modulo: Brand Showcase (bsh)
   Tab rail + panel swap + a quick-add that UPGRADES a form which already works.

   `window.moduloLazyInit` is deliberately NOT used — it does not exist. Roadmap
   rule 5 mandates it and `extensions/modulo-theme/assets/modulo-core.js` is not
   on disk; 73 sections carry the dead call. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* A non-2xx must become a real Error carrying its status, or a 422 takes the
     success path on an add that never happened. */
  function thenJson(res) {
    return res.json()
      .catch(function () { return {}; })
      .then(function (data) {
        if (res.ok) return data;
        var err = new Error((data && (data.description || data.message)) || 'Could not add');
        err.status = res.status;
        throw err;
      });
  }

  function initSection(sectionEl) {
    if (sectionEl.moduloBsh) return;
    sectionEl.moduloBsh = true;

    var rail = sectionEl.querySelector('[data-bsh-rail]');
    var wrap = sectionEl.querySelector('[data-bsh-railwrap]');
    var tabs = [].slice.call(sectionEl.querySelectorAll('[data-bsh-tab]'));
    var panels = [].slice.call(sectionEl.querySelectorAll('[data-bsh-panel]'));
    var navs = [].slice.call(sectionEl.querySelectorAll('[data-bsh-nav]'));
    if (!rail || !tabs.length) return;

    /* ─── The brand rail ─────────────────────────────────────────────────── */
    function syncRail() {
      var fits = rail.scrollWidth <= rail.clientWidth + 1;
      for (var i = 0; i < navs.length; i++) navs[i].hidden = fits;
      if (fits) {
        wrap.setAttribute('data-start', '1');
        wrap.setAttribute('data-end', '1');
        return;
      }
      var max = rail.scrollWidth - rail.clientWidth;
      /* A spec-compliant RTL scroller runs 0 -> negative, so the model is
         measured, never sniffed. */
      var pos = Math.abs(rail.scrollLeft);
      wrap.setAttribute('data-start', pos <= 2 ? '1' : '0');
      wrap.setAttribute('data-end', pos >= max - 2 ? '1' : '0');
      for (var j = 0; j < navs.length; j++) {
        var dir = parseInt(navs[j].getAttribute('data-bsh-nav'), 10);
        navs[j].disabled = dir < 0 ? pos <= 2 : pos >= max - 2;
      }
    }

    function select(index) {
      for (var i = 0; i < tabs.length; i++) {
        var on = i === index;
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].tabIndex = on ? 0 : -1;
      }
      for (var k = 0; k < panels.length; k++) {
        var live = k === index;
        panels[k].hidden = !live;
        panels[k].classList.remove('is-in');
        if (live) {
          void panels[k].offsetWidth;   /* restart the transition */
          panels[k].classList.add('is-in');
        }
      }
      /* Bring the chosen pill fully into view without yanking the rail. */
      var pill = tabs[index];
      if (pill) {
        var left = pill.offsetLeft;
        var right = left + pill.offsetWidth;
        if (left < rail.scrollLeft) rail.scrollLeft = left - 16;
        else if (right > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = right - rail.clientWidth + 16;
      }
      syncCards(panels[index]);
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (i) {
        tabs[i].addEventListener('click', function () { select(i); });
        tabs[i].addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          if (next === null) return;
          e.preventDefault();
          select(next);
          tabs[next].focus();
        });
      })(t);
    }

    for (var n = 0; n < navs.length; n++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-bsh-nav'), 10);
          rail.scrollLeft += dir * Math.round(rail.clientWidth * 0.7);
        });
      })(navs[n]);
    }
    rail.addEventListener('scroll', syncRail, { passive: true });

    /* ─── The product rail inside each panel ─────────────────────────────── */
    function syncCards(panel) {
      if (!panel) return;
      var cards = panel.querySelector('[data-bsh-cards]');
      var btn = panel.querySelector('[data-bsh-cardnav]');
      if (!cards || !btn) return;
      var max = cards.scrollWidth - cards.clientWidth;
      btn.disabled = max <= 2 || Math.abs(cards.scrollLeft) >= max - 2;
      /* Park the arrow on the product photo's midline, not the card's — the
         card's lower half is caption, so 50% would sit under the price. */
      var plate = cards.querySelector('.modulo-bsh__plate');
      if (plate) btn.style.top = (plate.offsetHeight / 2 - 18) + 'px';
    }

    for (var p = 0; p < panels.length; p++) {
      (function (panel) {
        var cards = panel.querySelector('[data-bsh-cards]');
        var btn = panel.querySelector('[data-bsh-cardnav]');
        if (!cards) return;
        if (btn) {
          btn.addEventListener('click', function () {
            cards.scrollLeft += Math.round(cards.clientWidth * 0.8);
          });
        }
        cards.addEventListener('scroll', function () { syncCards(panel); }, { passive: true });
      })(panels[p]);
    }

    /* ─── Quick add ──────────────────────────────────────────────────────── */
    /* Progressive enhancement: the markup is already a working product form,
       and this only upgrades it. Standing down on defaultPrevented leaves the
       bundle block's own handler in charge where it should be. */
    sectionEl.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      var form = e.target.closest('[data-bsh-form]');
      if (!form || !sectionEl.contains(form)) return;
      var button = form.querySelector('[data-bsh-add]');
      var card = form.closest('[data-bsh-card]');
      if (!button || !card) return;
      e.preventDefault();
      add(form, button, card);
    });

    function add(form, button, card) {
      /* The in-flight flag lives on the CARD. A per-button flag cannot see its
         sibling, so two controls would mean two concurrent adds. */
      if (card.moduloBshBusy) return;
      card.moduloBshBusy = true;
      button.classList.add('is-busy');

      var field = form.querySelector('[name="id"]');
      var id = field && field.value;
      if (!id) { done(); return; }

      window.fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          /* Opts out of the bundle block's in-flight fetch shim, which would
             otherwise answer with a synthetic 200 {"items":[]} and take the
             success path on an add that never happened. */
          'X-Modulo-Internal': 'brand-showcase'
        },
        /* No `sections` here on purpose: an invalid one returns 400 for the
           WHOLE request while the add still succeeds, so a caller treating
           non-2xx as failure would skip every refresh on an item now in the
           cart. ModuloCart.after() asks for sections on the /cart.js read. */
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(thenJson)
        .then(function () {
          if (window.ModuloCart) return window.ModuloCart.after({ open: false });
        })
        .catch(function () {
          /* The form still works without us — hand the shopper back to the
             native path rather than silently swallowing the failure. */
          form.submit();
        })
        .then(done, done);

      function done() {
        card.moduloBshBusy = false;
        button.classList.remove('is-busy');
      }
    }

    /* One observer per section; re-measures both rails on any reflow. */
    if (window.ResizeObserver) {
      new window.ResizeObserver(function () {
        syncRail();
        for (var i = 0; i < panels.length; i++) {
          if (!panels[i].hidden) syncCards(panels[i]);
        }
      }).observe(sectionEl);
    }

    /* Webfonts land after a deferred script and change every pill's width. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { syncRail(); });
    }

    syncRail();
    syncCards(panels[0]);
  }

  function bootstrap(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-bsh]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  /* An identical <script src> still executes once per tag, so guard the
     document-level listeners. */
  if (!window.moduloBshWired) {
    window.moduloBshWired = true;
    document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
})();
